import axios from "axios";
import dayjs, { isDayjs } from "dayjs";

import { formatRequestData } from "./funcs";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axiosInstance.interceptors.request.use(
  (req) => {
    if (req.params) {
      Object.keys(req.params).forEach((key) => {
        if (req.params[key] instanceof Date || isDayjs(req.params[key])) {
          req.params[key] = dayjs(req.params[key]).format("YYYY-MM-DD");
        }
        if (
          req.params[key] === "all" ||
          req.params[key] === "" ||
          typeof req.params[key] === "undefined"
        ) {
          delete req.params[key];
        }
      });
    }
    if (req.method === "post" || req.method === "put") {
      if (
        req.data &&
        !(req.data instanceof FormData) &&
        !(req.data instanceof URLSearchParams)
      ) {
        req.data = formatRequestData(req.data);
      }
    }
    return req;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => {
    const _error = {
      data: error?.response?.data?.data || null,
      message: error?.response?.data?.message || error?.message || "",
      status: error?.response?.status,
    };

    return Promise.reject(_error);
  }
);
